import React, { useEffect, useState } from "react";
import API from "../../../utils";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Scorecard = () => {
    const uid = localStorage.getItem("user_id");

    const [formData, setFormData] = useState({
        Scorecardsingular: "",
        scorecardPagename: "",
        Scorecardplural: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formDataToSend = new FormData();
        formDataToSend.append('user_id', uid);
        formDataToSend.append('page_name', formData.scorecardPagename);
        formDataToSend.append('scorecard', formData.Scorecardsingular);
        formDataToSend.append('scorecent', formData.Scorecardplural);

        try {
            const response = await axios.post(
                `${API.BASE_URL}${API.ENDPOINTS.add_update_terminology_scorecard}`,
                formDataToSend,
                {
                    headers: {
                        Authorization: `${API.AUTHORIZATION_TOKEN}`,
                    },
                }
            );

            if (response.data.status === "success") {
                toast.success(response.data.message);
                fetchData();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("Error during task submission:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        const formDataToSend = new FormData();
        formDataToSend.append('user_id', uid);

        try {
            const response = await axios.post(
                `${API.BASE_URL}${API.ENDPOINTS.get_my__scorecard_data}`,
                formDataToSend,
                {
                    headers: {
                        Authorization: `${API.AUTHORIZATION_TOKEN}`,
                    },
                }
            );

            if (response.data.status === 'success') {
                const data = response.data.info;
                setFormData({
                    scorecardPagename: data.page_name || "",
                    Scorecardsingular: data.scorecard || "",
                    Scorecardplural: data.scorecent || "",
                });
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Error during task fetching:', error);
        }
    };

    return (
        <>
            <div className="card">
                <div className="card-header">
                    <h5 className="card-title mb-0"><i className="icofont icofont-pie-chart mx-2"></i>Scorecard</h5>
                </div>
                <div className="card-body">
                    <form>
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <div className="form-group mb-2">
                                    <label className="col-sm-12 col-form-label"><b>Page Name</b></label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Enter scorecardPagename"
                                        name="scorecardPagename"
                                        value={formData.scorecardPagename}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div className="form-group mb-2">
                                    <label className="col-sm-12 col-form-label"><b>Scorecard (singular)</b></label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Enter Scorecard"
                                        name="Scorecardsingular"
                                        value={formData.Scorecardsingular}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div className="form-group mb-2">
                                    <label className="col-sm-12 col-form-label"><b>Scorecards (plural)</b></label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Enter Scorecards (plural)"
                                        name="Scorecardplural"
                                        value={formData.Scorecardplural}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-end align-content-center">
                                <button type="submit" className="btn btn-success" onClick={handleSubmit}>Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default Scorecard;
